// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { __decorate, __metadata, __param } from "tslib";
import { Inject, Scoped } from 'vue-di';
/* tslint:disable:no-unused-locals */
import { Serializer, } from '@trialcard/apigateway.models';
import { OAuth, OAuthTokenProvider, OAUTH_TOKEN_PROVIDER } from '@trialcard/authentication';
import { X_TC_USERID } from '@trialcard/shared';
import { AXIOS, AUDIENCE, BASE_PATH } from './symbols';
// ===============================================
// This file is autogenerated - Please do not edit
// ===============================================
let EdgeMedicalApi = class EdgeMedicalApi {
    constructor(axios, xTcUserId, audience, url, tokenProvider) {
        this.axios = axios;
        this.authentications = {
            'Token': new OAuth({ name: 'apigateway', url, audience }, tokenProvider),
        };
        if (this.authentications.UserId) {
            this.authentications.UserId.apiKey = xTcUserId;
        }
    }
    /**
     *
     * @param MedicalBiRequest default request body
     * @param x_program_id The program id from the list of allowed program ids
     */
    async medicalV1MedicalBi(MedicalBiRequest, x_program_id) {
        const _url_ = '/edge/medical/v1/MedicalBi';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'MedicalBiRequest' is not null or undefined
        if (MedicalBiRequest === null || MedicalBiRequest === undefined) {
            throw new Error('Required parameter MedicalBiRequest was null or undefined when calling medicalV1MedicalBi.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(MedicalBiRequest, "MedicalBiRequest"),
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "MedicalV1MedicalBiDefaultResponse");
        }
        return response;
    }
    /**
     *
     * @param MedicalBiRequestSearchRequest default request body
     * @param x_program_id The program id from the list of allowed program ids
     */
    async medicalV1MedicalBiRequestSearch(MedicalBiRequestSearchRequest, x_program_id) {
        const _url_ = '/edge/medical/v1/MedicalBiRequestSearch';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'MedicalBiRequestSearchRequest' is not null or undefined
        if (MedicalBiRequestSearchRequest === null || MedicalBiRequestSearchRequest === undefined) {
            throw new Error('Required parameter MedicalBiRequestSearchRequest was null or undefined when calling medicalV1MedicalBiRequestSearch.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(MedicalBiRequestSearchRequest, "MedicalBiRequestSearchRequest"),
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "MedicalV1MedicalBiRequestSearchDefaultResponse");
        }
        return response;
    }
    /**
     *
     * @param MedicalBiResultSearchRequest default request body
     * @param x_program_id The program id from the list of allowed program ids
     */
    async medicalV1MedicalBiResultSearch(MedicalBiResultSearchRequest, x_program_id) {
        const _url_ = '/edge/medical/v1/MedicalBiResultSearch';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'MedicalBiResultSearchRequest' is not null or undefined
        if (MedicalBiResultSearchRequest === null || MedicalBiResultSearchRequest === undefined) {
            throw new Error('Required parameter MedicalBiResultSearchRequest was null or undefined when calling medicalV1MedicalBiResultSearch.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(MedicalBiResultSearchRequest, "MedicalBiResultSearchRequest"),
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "MedicalV1MedicalBiResultSearchDefaultResponse");
        }
        return response;
    }
};
EdgeMedicalApi = __decorate([
    Scoped,
    __param(0, Inject(AXIOS)),
    __param(1, Inject(X_TC_USERID)),
    __param(2, Inject(AUDIENCE)),
    __param(3, Inject(BASE_PATH)),
    __param(4, Inject(OAUTH_TOKEN_PROVIDER)),
    __metadata("design:paramtypes", [Function, String, String, String, OAuthTokenProvider])
], EdgeMedicalApi);
export { EdgeMedicalApi };
//# sourceMappingURL=edgeMedicalApi.js.map